<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.bankruptcy.requestApplicant.socialIdType"
          :value.sync="info.identityTypeId"
          :items="identityTypes"
          item-text="name"
          item-value="id"
          :disabled="isDisabled"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.requestApplicant.socialId"
          :value.sync="info.identityNumber"
          :disabled="isDisabled"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="6"
      >
        <naj-input
          :type-id="formFieldType.date"
          :label="local.bankruptcy.requestApplicant.birthDate"
          :value.sync="info.dateOfBirth"
          item-text="name"
          item-value="id"
          :disabled="isDisabled"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.requestApplicant.firstName"
          :value.sync="info.firstName"
          item-text="name"
          item-value="id"
          :disabled="isDisabled"
        ></naj-input>
      </v-col>
      <v-col
        md="6"
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.requestApplicant.fatherName"
          :value.sync="info.fatherName"
          item-text="name"
          item-value="id"
          :disabled="isDisabled"
        ></naj-input>
      </v-col>
      <v-col
        md="6"
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.requestApplicant.thirdName"
          :value.sync="info.thirdName"
          item-text="name"
          item-value="id"
          :disabled="isDisabled"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.requestApplicant.familyName"
          :value.sync="info.familyName"
          item-text="name"
          item-value="id"
          :disabled="isDisabled"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        md="6"
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.bankruptcy.requestApplicant.nationality"
          :value.sync="info.nationality"
          :items="countries"
          item-text="name"
          item-value="id"
          :disabled="isDisabled"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :label="local.bankruptcy.requestApplicant.gender"
          :value.sync="info.gender"
          :items="genders"
          item-text="name"
          item-value="id"
          :disabled="isDisabled"
        ></naj-input>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState, mapActions } = createNamespacedHelpers('BankruptcyModule');
export default {
  name: 'ApplicantInfo',
  props: {
    info: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { isDisabled: true };
  },
  computed: { ...mapLUTState(['genders', 'countries', 'identityTypes']) },
  created() {
    this.getIdentityTypes();
    this.getCountries();
  },
  methods: {
    ...mapActions([
      'getIdentityTypes',
      'getCountries',
    ]),
  },
};
</script>

<style lang="scss">
</style>
